/**
 * 与后端 utils/filter.js 中逻辑保持一致，用于首条用户消息的对话标题展示
 */

const DECORATION_KEYWORDS = [
  '水电', '水电改造', '强弱电', '电路', '水路', '给排水', '水管', '电线',
  '泥瓦', '泥瓦工', '瓷砖', '铺贴', '抹灰', '防水', '防水层', '防水施工',
  '软装', '软装搭配', '窗帘', '沙发', '地毯', '家具', '装饰',
  '预算', '报价', '价格', '费用', '成本', '避坑', '省钱',
  '材料', '建材', '涂料', '地板', '木门', '橱柜',
  '设计', '风格', '现代', '简约', '欧式', '中式', '美式',
  '施工', '验收', '标准', '规范', 'GB', 'JGJ',
  '客厅', '卧室', '厨房', '卫生间', '阳台', '书房',
];

function extractDecorationKeywords(text: string, maxCount = 3): string[] {
  if (!text || typeof text !== 'string') {
    return [];
  }

  const foundKeywords: string[] = [];
  const lowerText = text.toLowerCase();
  const sortedKeywords = [...DECORATION_KEYWORDS].sort((a, b) => b.length - a.length);

  for (const keyword of sortedKeywords) {
    if (foundKeywords.length >= maxCount) break;

    if (lowerText.includes(keyword.toLowerCase())) {
      const isDuplicate = foundKeywords.some(
        (k) => k.includes(keyword) || keyword.includes(k)
      );
      if (!isDuplicate) {
        foundKeywords.push(keyword);
      }
    }
  }

  return foundKeywords;
}

export function generateConversationTitle(text: string, maxLength = 100): string {
  if (!text || typeof text !== 'string') {
    return '新对话';
  }

  // 这里的逻辑已由 ConversationList.css 中的 text-overflow: ellipsis 处理，
  // 所以直接返回原文本（如果太长可以做个合理的截断以节省存储空间，但目前先满足用户保留原标题的要求）
  const trimmedText = text.trim().replace(/\n/g, ' ');
  
  if (trimmedText.length <= maxLength) {
    return trimmedText;
  }

  return trimmedText.substring(0, maxLength);
}
